import { render } from "./hydw.vue?vue&type=template&id=59d6b4d5&scoped=true&ts=true"
import script from "./hydw.vue?vue&type=script&lang=ts"
export * from "./hydw.vue?vue&type=script&lang=ts"

import "./hydw.vue?vue&type=style&index=0&id=59d6b4d5&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d6b4d5"]])

export default __exports__